module.exports = __webpack_public_path__ + "static/media/my-asynch-courses-empty-state.5cedee91.svg";